export const createMediaCollection = (mediaIndex, uploadedFile, originalFile = {}) => {
  return {
    "idShort": `Media${mediaIndex}`,
    "displayName": [
      {
        "language": "en",
        "text": `Anhang ${mediaIndex}`
      },
      {
        "language": "de",
        "text": `Media ${mediaIndex}`
      }
    ],
    "description": [
      {
        "language": "en",
        "text": "File attached to the notification"
      },
      {
        "language": "de",
        "text": "Datei, die als Beilage an die Meldung gef\u00FCgt"
      }
    ],
    "semanticId": {
      "type": "ExternalReference",
      "keys": [
        {
          "type": "GlobalReference",
          "value": "0173-1#02-ABI791#001/0173-1#01-AHX447#001"
        }
      ]
    },
    "value": [
      {
        "idShort": "DigitalFile",
        "displayName": [
          {
            "language": "en",
            "text": "Digital File"
          },
          {
            "language": "de",
            "text": "Digitale Datei"
          }
        ],
        "description": [
          {
            "language": "en",
            "text": "Computer resource for recording data in a computer storage device, primarily identified by its file name"
          },
          {
            "language": "de",
            "text": "Computerressource zur Aufzeichnung von Daten in einem Computerspeicherger\u00E4t, die in erster Linie durch ihren Dateinamen identifiziert wird"
          }
        ],
        "semanticId": {
          "type": "ExternalReference",
          "keys": [
            {
              "type": "GlobalReference",
              "value": "0173-1#02-ABK126#001"
            }
          ]
        },

        "value": uploadedFile.url,
        "contentType": originalFile.type || "application/octet-stream",
        "modelType": "File"
      },
      {
        "idShort": "Comment",
        "displayName": [
          {
            "language": "en",
            "text": "Comment to File"
          },
          {
            "language": "de",
            "text": "Anmerkung zur Datei"
          }
        ],
        "description": [
          {
            "language": "en",
            "text": "Explanations that refer to the attached file and relate to its use or origin"
          },
          {
            "language": "de",
            "text": "Erl\u00E4uterungen die sich auf die Angeh\u00E4ngte Datei beziehen und sich auf deren Verwendung oder Ursprung beziehen"
          }
        ],
        "semanticId": {
          "type": "ExternalReference",
          "keys": [
            {
              "type": "GlobalReference",
              "value": "0173-1#02-ABI768#001"
            }
          ]
        },
        "value": [
          { language: "en", text: `Uploaded image ${mediaIndex}: ${uploadedFile.filename}` },
          { language: "de", text: `Hochgeladenes Bild ${mediaIndex}: ${uploadedFile.filename}` }
        ],
        "modelType": "MultiLanguageProperty"
      }
    ],
    "modelType": "SubmodelElementCollection"
  }
};

export const createAttachedMediaCollection = (uploadedMedia = []) => {
  const numberOfMedia = uploadedMedia.length;

  return {
    "idShort": "AttachedMedia",
    "displayName": [
      {
        "language": "en",
        "text": "Attached media"
      },
      {
        "language": "de",
        "text": "Angeh\u00E4ngte Dateien"
      }
    ],
    "description": [
      {
        "language": "en",
        "text": "Collection of file attachments that complement the notification and present additional information for processing the notification"
      },
      {
        "language": "de",
        "text": "Sammlung von Dateianh\u00E4ngen, welche die Meldung erg\u00E4nzen und Zusatzinformatioen zur effizienten Bearbeitung der Meldung darstellen"
      }
    ],
    "semanticId": {
      "type": "ExternalReference",
      "keys": [
        {
          "type": "GlobalReference",
          "value": "0173-1#02-ABI790#001/0173-1#01-AHX446#001"
        }
      ]
    },
    "value": [
      {
        "idShort": "NumberOfMedia",
        "displayName": [
          {
            "language": "en",
            "text": "Number of Media"
          },
          {
            "language": "de",
            "text": "Anzahl der Anh\u00E4nge"
          }
        ],
        "semanticId": {
          "type": "ExternalReference",
          "keys": [
            {
              "type": "GlobalReference",
              "value": "0173-1#02-ABI767#001"
            }
          ]
        },
        "valueType": "xs:string",
        "value": String(numberOfMedia),
        "modelType": "Property"
      }
    ],
    "modelType": "SubmodelElementCollection"
  }
};

export const serviceRequestNotification =
{
  "idShort": "ServiceRequestNotification1",
  "displayName": [
    {
      "language": "en",
      "text": "Service Request Notification 1"
    },
    {
      "language": "de",
      "text": "Servicebedarfsmeldung 1"
    }
  ],
  "description": [
    {
      "language": "en",
      "text": "Collection of information with which notifications are recorded and managed in the service and customer service area"
    },
    {
      "language": "de",
      "text": "Sammlung von Informationen mit denen im Service- und Kundendienstbereich Meldungen erfasst und verwaltet werden"
    }
  ],
  "semanticId": {
    "type": "ExternalReference",
    "keys": [
      {
        "type": "GlobalReference",
        "value": "0173-1#02-ABI788#001/0173-1#01-AHX444#001"
      }
    ]
  },
  "value": [
    {
      "idShort": "ReportedBy",
      "displayName": [
        {
          "language": "en",
          "text": "Reported By"
        },
        {
          "language": "de",
          "text": "Gemeldet von"
        }
      ],
      "description": [
        {
          "language": "en",
          "text": "Collection of one or more natural persons or assets that creates or publicizes the message"
        },
        {
          "language": "de",
          "text": "Sammlung von einer oder mehreren nat\u00FCrlichen Personen oder einem Asset, welches die Meldung erstellt oder bekannt macht"
        }
      ],
      "semanticId": {
        "type": "ExternalReference",
        "keys": [
          {
            "type": "GlobalReference",
            "value": "0173-1#02-ABI792#00/0173-1#01-AHX448#001"
          }
        ]
      },
      "value": [
        {
          "idShort": "CustomerNumber",
          "displayName": [
            {
              "language": "en",
              "text": "Customer Number"
            },
            {
              "language": "de",
              "text": "Kundennummer"
            }
          ],
          "description": [
            {
              "language": "en",
              "text": "An alphanumeric key that identifies a customer"
            },
            {
              "language": "de",
              "text": "Ein alphanumerischer Schl\u00FCssel, der einen Kunden identifiziert"
            }
          ],
          "semanticId": {
            "type": "ExternalReference",
            "keys": [
              {
                "type": "GlobalReference",
                "value": "0173-1#02-ABI769#001"
              }
            ]
          },
          "valueType": "xs:string",
          "modelType": "Property"
        },
        {
          "idShort": "SenderSystem",
          "displayName": [
            {
              "language": "en",
              "text": "Sender System"
            },
            {
              "language": "de",
              "text": "Sendendes System"
            }
          ],
          "description": [
            {
              "language": "en",
              "text": "System, that creates or makes known the notification"
            },
            {
              "language": "de",
              "text": "System, welches die Meldung erstellt oder bekannt macht"
            }
          ],
          "semanticId": {
            "type": "ExternalReference",
            "keys": [
              {
                "type": "GlobalReference",
                "value": "0173-1#02-ABI770#001"
              }
            ]
          },
          "entityType": "SelfManagedEntity",
          "modelType": "Entity"
        },
        {
          "idShort": "NumberOfContacts",
          "displayName": [
            {
              "language": "en",
              "text": "Number of Contacts"
            },
            {
              "language": "de",
              "text": "Anzahl der Kontakte"
            }
          ],
          "semanticId": {
            "type": "ExternalReference",
            "keys": [
              {
                "type": "GlobalReference",
                "value": "0173-1#02-AAO203#004"
              }
            ]
          },
          "valueType": "xs:string",
          "modelType": "Property"
        },
        {
          "idShort": "ContactInformation",
          "displayName": [
            {
              "language": "en",
              "text": "Contact Information"
            },
            {
              "language": "de",
              "text": "Kontaktinformation"
            }
          ],
          "description": [
            {
              "language": "en",
              "text": "The SMC \u201CContactInformation\u201D contains information on how to contact the manufacturer or an authorised service provider, e.g. when a maintenance service is required. Note: physical address is a mandatory property according to EU Machine Directive 2006/42/EC"
            },
            {
              "language": "de",
              "text": "Die SMC-\u201EKontaktinformationen\u201C enthalten Angaben zur Kontaktaufnahme mit dem Hersteller oder einem autorisierten Servicepartner, z. B. im Wartungsfall. Hinweis: Die Angabe einer physischen Adresse ist gem\u00E4\u00DF EU-Maschinenrichtlinie 2006/42/EG obligatorisch."
            }
          ],
          "semanticId": {
            "type": "ExternalReference",
            "keys": [
              {
                "type": "GlobalReference",
                "value": "0173-1#02-AAQ837#007/0173-1#01-ADR448#007"
              }
            ]
          },
          "qualifiers": [
            {
              "type": "Multiplicity",
              "valueType": "xs:string",
              "value": "One"
            }
          ],
          "value": [
            {
              "idShort": "NationalCode",
              "displayName": [
                {
                  "language": "en",
                  "text": "National Code"
                },
                {
                  "language": "de",
                  "text": "Nationaler Code"
                }
              ],
              "description": [
                {
                  "language": "en",
                  "text": "Code of a country"
                },
                {
                  "language": "de",
                  "text": "Code eines Landes"
                }
              ],
              "semanticId": {
                "type": "ExternalReference",
                "keys": [
                  {
                    "type": "GlobalReference",
                    "value": "0173-1#02-AAO134#002"
                  }
                ]
              },
              "qualifiers": [
                {
                  "type": "Multiplicity",
                  "valueType": "xs:string",
                  "value": "One"
                }
              ],
              "value": [
                {
                  "language": "de",
                  "text": ""
                }
              ],
              "modelType": "MultiLanguageProperty"
            },
            {
              "idShort": "CityTown",
              "displayName": [
                {
                  "language": "en",
                  "text": "City/Town"
                },
                {
                  "language": "de",
                  "text": "Stadt/Gemeinde"
                }
              ],
              "description": [
                {
                  "language": "en",
                  "text": "Town or city"
                },
                {
                  "language": "de",
                  "text": "Stadt"
                }
              ],
              "semanticId": {
                "type": "ExternalReference",
                "keys": [
                  {
                    "type": "GlobalReference",
                    "value": "0173-1#02-AAO132#002"
                  }
                ]
              },
              "qualifiers": [
                {
                  "type": "Multiplicity",
                  "valueType": "xs:string",
                  "value": "One"
                }
              ],
              "value": [
                {
                  "language": "de",
                  "text": ""
                }
              ],
              "modelType": "MultiLanguageProperty"
            },
            {
              "idShort": "Company",
              "displayName": [
                {
                  "language": "en",
                  "text": "Company"
                },
                {
                  "language": "de",
                  "text": "Firma"
                }
              ],
              "description": [
                {
                  "language": "en",
                  "text": "Name of the company"
                },
                {
                  "language": "de",
                  "text": "Name des Unternehmens"
                }
              ],
              "semanticId": {
                "type": "ExternalReference",
                "keys": [
                  {
                    "type": "GlobalReference",
                    "value": "0173-1#02-AAW001#001"
                  }
                ]
              },
              "qualifiers": [
                {
                  "type": "Multiplicity",
                  "valueType": "xs:string",
                  "value": "ZeroToOne"
                }
              ],
              "value": [
                {
                  "language": "de",
                  "text": ""
                }
              ],
              "modelType": "MultiLanguageProperty"
            },
            {
              "idShort": "Phone",
              "displayName": [
                {
                  "language": "en",
                  "text": "Phone"
                },
                {
                  "language": "de",
                  "text": "Telefon"
                }
              ],
              "description": [
                {
                  "language": "en",
                  "text": "Phone number including type"
                },
                {
                  "language": "de",
                  "text": "Telefonnummer inklusive Typ"
                }
              ],
              "semanticId": {
                "type": "ExternalReference",
                "keys": [
                  {
                    "type": "GlobalReference",
                    "value": "https://admin-shell.io/zvei/nameplate/1/0/ContactInformations/ContactInformation/Phone"
                  }
                ]
              },
              "qualifiers": [
                {
                  "type": "Multiplicity",
                  "valueType": "xs:string",
                  "value": "ZeroToOne"
                }
              ],
              "value": [
                {
                  "idShort": "TelephoneNumber",
                  "displayName": [
                    {
                      "language": "en",
                      "text": "Telephone Number"
                    },
                    {
                      "language": "de",
                      "text": "Telefonnummer"
                    }
                  ],
                  "description": [
                    {
                      "language": "en",
                      "text": "Complete telephone number to be called to reach a business partner"
                    },
                    {
                      "language": "de",
                      "text": "Vollst\u00E4ndige Telefonnummer, unter der ein Gesch\u00E4ftspartner erreichbar ist"
                    }
                  ],
                  "semanticId": {
                    "type": "ExternalReference",
                    "keys": [
                      {
                        "type": "GlobalReference",
                        "value": "0173-1#02-AAO136#002"
                      }
                    ]
                  },
                  "qualifiers": [
                    {
                      "type": "Multiplicity",
                      "valueType": "xs:string",
                      "value": "One"
                    }
                  ],
                  "value": [
                    {
                      "language": "de",
                      "text": ""
                    }
                  ],
                  "modelType": "MultiLanguageProperty"
                }
              ],
              "modelType": "SubmodelElementCollection"
            },
            {
              "idShort": "Email",
              "displayName": [
                {
                  "language": "en",
                  "text": "Email"
                },
                {
                  "language": "de",
                  "text": "E-Mail"
                }
              ],
              "description": [
                {
                  "language": "en",
                  "text": "E-mail address and encryption method"
                },
                {
                  "language": "de",
                  "text": "E-Mail-Adresse und Verschl\u00FCsselungsmethode"
                }
              ],
              "semanticId": {
                "type": "ExternalReference",
                "keys": [
                  {
                    "type": "GlobalReference",
                    "value": "0173-1#02-AAQ836#005"
                  }
                ]
              },
              "qualifiers": [
                {
                  "type": "Multiplicity",
                  "valueType": "xs:string",
                  "value": "ZeroToOne"
                }
              ],
              "value": [
                {
                  "idShort": "EmailAddress",
                  "displayName": [
                    {
                      "language": "en",
                      "text": "Email Address"
                    },
                    {
                      "language": "de",
                      "text": "E-Mail-Adresse"
                    }
                  ],
                  "description": [
                    {
                      "language": "en",
                      "text": "Electronic mail address of a business partner"
                    },
                    {
                      "language": "de",
                      "text": "E-Mail-Adresse eines Gesch\u00E4ftspartners"
                    }
                  ],
                  "semanticId": {
                    "type": "ExternalReference",
                    "keys": [
                      {
                        "type": "GlobalReference",
                        "value": "0173-1#02-AAO198#002"
                      }
                    ]
                  },
                  "qualifiers": [
                    {
                      "type": "Multiplicity",
                      "valueType": "xs:string",
                      "value": "One"
                    }
                  ],
                  "valueType": "xs:string",
                  "value": "",
                  "modelType": "Property"
                }
              ],
              "modelType": "SubmodelElementCollection"
            },
            {
              "idShort": "Street",
              "displayName": [
                {
                  "language": "en",
                  "text": "Street"
                },
                {
                  "language": "de",
                  "text": "Stra\u00DFe"
                }
              ],
              "description": [
                {
                  "language": "en",
                  "text": "Street name and house number"
                },
                {
                  "language": "de",
                  "text": "Stra\u00DFenname und Hausnummer"
                }
              ],
              "semanticId": {
                "type": "ExternalReference",
                "keys": [
                  {
                    "type": "GlobalReference",
                    "value": "0173-1#02-AAO128#002"
                  }
                ]
              },
              "qualifiers": [
                {
                  "type": "Multiplicity",
                  "valueType": "xs:string",
                  "value": "One"
                }
              ],
              "value": [
                {
                  "language": "de",
                  "text": ""
                }
              ],
              "modelType": "MultiLanguageProperty"
            },
            {
              "idShort": "Zipcode",
              "displayName": [
                {
                  "language": "en",
                  "text": "Zip Code"
                },
                {
                  "language": "de",
                  "text": "Postleitzahl"
                }
              ],
              "description": [
                {
                  "language": "en",
                  "text": "ZIP code of address"
                },
                {
                  "language": "de",
                  "text": "Postleitzahl der Adresse"
                }
              ],
              "semanticId": {
                "type": "ExternalReference",
                "keys": [
                  {
                    "type": "GlobalReference",
                    "value": "0173-1#02-AAO129#002"
                  }
                ]
              },
              "qualifiers": [
                {
                  "type": "Multiplicity",
                  "valueType": "xs:string",
                  "value": "One"
                }
              ],
              "value": [
                {
                  "language": "de",
                  "text": ""
                }
              ],
              "modelType": "MultiLanguageProperty"
            },
            {
              "idShort": "StateCounty",
              "displayName": [
                {
                  "language": "en",
                  "text": "State/County"
                },
                {
                  "language": "de",
                  "text": "Bundesland/Kreis"
                }
              ],
              "description": [
                {
                  "language": "en",
                  "text": "Federal state a part of a state"
                },
                {
                  "language": "de",
                  "text": "Bundesstaat, Teil eines Bundesstaates"
                }
              ],
              "semanticId": {
                "type": "ExternalReference",
                "keys": [
                  {
                    "type": "GlobalReference",
                    "value": "0173-1#02-AAO133#002"
                  }
                ]
              },
              "qualifiers": [
                {
                  "type": "Multiplicity",
                  "valueType": "xs:string",
                  "value": "ZeroToOne"
                }
              ],
              "value": [
                {
                  "language": "de",
                  "text": ""
                }
              ],
              "modelType": "MultiLanguageProperty"
            }
          ],
          "modelType": "SubmodelElementCollection"
        }
      ],
      "modelType": "SubmodelElementCollection"
    },
    {
      "idShort": "ServiceRequestNotificationId",
      "displayName": [
        {
          "language": "en",
          "text": "ID of Service Request Notification"
        },
        {
          "language": "de",
          "text": "ID der Bedarfsmeldung"
        }
      ],
      "description": [
        {
          "language": "en",
          "text": "Number assigned by an entity to the notification in order to uniquely identify and reference it in the further process flow"
        },
        {
          "language": "de",
          "text": "Nummer, die von einer Stelle der Meldung zugewiesen wird, um sie im weiteren Prozessablauf eindeutig zu identifizieren und zu referenzieren"
        }
      ],
      "semanticId": {
        "type": "ExternalReference",
        "keys": [
          {
            "type": "GlobalReference",
            "value": "0173-1#02-ABI772#001"
          }
        ]
      },
      "valueType": "xs:string",
      "value": "",
      "modelType": "Property"
    },
    {
      "idShort": "Priority",
      "displayName": [
        {
          "language": "en",
          "text": "Priority of Notification"
        },
        {
          "language": "de",
          "text": "Priorit\u00E4t der Meldung"
        }
      ],
      "description": [
        {
          "language": "en",
          "text": "Rating of the primacy of the message, which results from the urgency or importance"
        },
        {
          "language": "de",
          "text": "Bewertung des Vorrangs der Meldung, welcher sich aufgrund der Dringlichkeit oder Wichtigkeit ergibt"
        }
      ],
      "semanticId": {
        "type": "ExternalReference",
        "keys": [
          {
            "type": "GlobalReference",
            "value": "0173-1#02-ABI773#001"
          }
        ]
      },
      "valueType": "xs:string",
      "value": "",
      "modelType": "Property"
    },
    {
      "idShort": "Status",
      "displayName": [
        {
          "language": "en",
          "text": "Status of Notification"
        },
        {
          "language": "de",
          "text": "Status der Meldung"
        }
      ],
      "description": [
        {
          "language": "en",
          "text": "Current processing status of the notification within the workflow"
        },
        {
          "language": "de",
          "text": "Aktueller Bearbeitungszustand der Meldung innerhalb des Arbeitsablaufs"
        }
      ],
      "semanticId": {
        "type": "ExternalReference",
        "keys": [
          {
            "type": "GlobalReference",
            "value": "0173-1#02-ABH938#002"
          }
        ]
      },
      "valueType": "xs:string",
      "value": "",
      "modelType": "Property"
    },
    {
      "idShort": "RelatedAsset",
      "displayName": [
        {
          "language": "en",
          "text": "Related Asset"
        },
        {
          "language": "de",
          "text": "Betroffenes Asset"
        }
      ],
      "description": [
        {
          "language": "en",
          "text": "The object affected by the notification activity"
        },
        {
          "language": "de",
          "text": "Das von der Meldungsaktivit\u00E4t betroffene Objekt"
        }
      ],
      "entityType": "SelfManagedEntity",
      "globalAssetId": "https://lorenz-meters.de/ids/asset/0102_4170_1132_0740",
      "specificAssetIds": [
        {
          "name": "serialNumber",
          "value": "8DWZ0323000613"
        }
      ],
      "modelType": "Entity"
    },
    {
      "idShort": "ShortText",
      "displayName": [
        {
          "language": "en",
          "text": "Short text of Service Request Notification"
        },
        {
          "language": "de",
          "text": "Kurztext zur Servicebedarfsmeldung"
        }
      ],
      "description": [
        {
          "language": "en",
          "text": "Brief textual description of the subject matter"
        },
        {
          "language": "de",
          "text": "Textuelle Kurzbeschreibung des Sachverhalts"
        }
      ],
      "semanticId": {
        "type": "ExternalReference",
        "keys": [
          {
            "type": "GlobalReference",
            "value": "0173-1#02-ABI762#001"
          }
        ]
      },
      "value": [
        {
          "language": "en",
          "text": ""
        },
        {
          "language": "de",
          "text": ""
        }
      ],
      "modelType": "MultiLanguageProperty"
    },
    {
      "idShort": "ServiceType",
      "displayName": [
        {
          "language": "en",
          "text": "Type of requested Service"
        },
        {
          "language": "de",
          "text": "Typ des notwendigen Service"
        }
      ],
      "description": [
        {
          "language": "en",
          "text": "Predefined classification of a requested service"
        },
        {
          "language": "de",
          "text": "Vordefinierte Klassifizierung einer angefragten Service-Dienstleistung"
        }
      ],
      "semanticId": {
        "type": "ExternalReference",
        "keys": [
          {
            "type": "GlobalReference",
            "value": "0173-1#02-ABI763#001"
          }
        ]
      },
      "valueType": "xs:string",
      "value": "",
      "modelType": "Property"
    },
    {
      "idShort": "DetailedInformation",
      "displayName": [
        {
          "language": "en",
          "text": "Detailed information of Service Need"
        },
        {
          "language": "de",
          "text": "Detailinformationen zum Servicebedarf"
        }
      ],
      "description": [
        {
          "language": "en",
          "text": "Collection of in-depth information describing the situation concerned in the service and customer support area"
        },
        {
          "language": "de",
          "text": "Sammlung von ausf\u00FChrlich Informationen mit denen der vorliegende Sachverhalt im Service- und Kundendienstbereich beschrieben wird"
        }
      ],
      "semanticId": {
        "type": "ExternalReference",
        "keys": [
          {
            "type": "GlobalReference",
            "value": "0173-1#02-ABI789#001/0173-1#01-AHX445#001"
          }
        ]
      },
      "value": [
        {
          "idShort": "LongText",
          "displayName": [
            {
              "language": "en",
              "text": "Long text of Service Request Notification"
            },
            {
              "language": "de",
              "text": "Langtext zur Servicebedarfsmeldung"
            }
          ],
          "description": [
            {
              "language": "en",
              "text": "Textual detailed description of the subject matter"
            },
            {
              "language": "de",
              "text": "Textuelle ausf\u00FChrliche Beschreibung des Sachverhalts"
            }
          ],
          "semanticId": {
            "type": "ExternalReference",
            "keys": [
              {
                "type": "GlobalReference",
                "value": "0173-1#02-ABI764#001"
              }
            ]
          },
          "value": [
            {
              "language": "de",
              "text": ""
            }
          ],
          "modelType": "MultiLanguageProperty"
        },
        {
          "idShort": "StartOfFault",
          "displayName": [
            {
              "language": "en",
              "text": "Start of fault"
            },
            {
              "language": "de",
              "text": "Beginn der St\u00F6rung"
            }
          ],
          "description": [
            {
              "language": "en",
              "text": "Point in time at which the regarded situation"
            },
            {
              "language": "de",
              "text": "Zeitpunkt, zu dem die betrachtete Situation"
            }
          ],
          "semanticId": {
            "type": "ExternalReference",
            "keys": [
              {
                "type": "GlobalReference",
                "value": "0173-1#02-ABI765#001"
              }
            ]
          },
          "valueType": "xs:dateTime",
          "modelType": "Property"
        },
        {
          "idShort": "ErrorCode",
          "displayName": [
            {
              "language": "en",
              "text": "Error code"
            },
            {
              "language": "de",
              "text": "Fehlercode"
            }
          ],
          "description": [
            {
              "language": "en",
              "text": "Technical key of the manufacturer for malfunction description"
            },
            {
              "language": "de",
              "text": "Technischer Schl\u00FCssel des Herstellers zur St\u00F6rungsbeschreibung"
            }
          ],
          "semanticId": {
            "type": "ExternalReference",
            "keys": [
              {
                "type": "GlobalReference",
                "value": "0173-1#02-ABI766#001"
              }
            ]
          },
          "valueType": "xs:string",
          "value": "",
          "modelType": "Property"
        },
        {
          "idShort": "AttachedMedia",
          "displayName": [
            {
              "language": "en",
              "text": "Attached media"
            },
            {
              "language": "de",
              "text": "Angeh\u00E4ngte Dateien"
            }
          ],
          "description": [
            {
              "language": "en",
              "text": "Collection of file attachments that complement the notification and present additional information for processing the notification"
            },
            {
              "language": "de",
              "text": "Sammlung von Dateianh\u00E4ngen, welche die Meldung erg\u00E4nzen und Zusatzinformatioen zur effizienten Bearbeitung der Meldung darstellen"
            }
          ],
          "semanticId": {
            "type": "ExternalReference",
            "keys": [
              {
                "type": "GlobalReference",
                "value": "0173-1#02-ABI790#001/0173-1#01-AHX446#001"
              }
            ]
          },
          "value": [
            {
              "idShort": "NumberOfMedia",
              "displayName": [
                {
                  "language": "en",
                  "text": "Number of Media"
                },
                {
                  "language": "de",
                  "text": "Anzahl der Anh\u00E4nge"
                }
              ],
              "semanticId": {
                "type": "ExternalReference",
                "keys": [
                  {
                    "type": "GlobalReference",
                    "value": "0173-1#02-ABI767#001"
                  }
                ]
              },
              "valueType": "xs:string",
              "value": "1",
              "modelType": "Property"
            },
            {
              "idShort": "Media1",
              "displayName": [
                {
                  "language": "en",
                  "text": "Anhang"
                },
                {
                  "language": "de",
                  "text": "Media"
                }
              ],
              "description": [
                {
                  "language": "en",
                  "text": "File attached to the notification"
                },
                {
                  "language": "de",
                  "text": "Datei, die als Beilage an die Meldung gef\u00FCgt"
                }
              ],
              "semanticId": {
                "type": "ExternalReference",
                "keys": [
                  {
                    "type": "GlobalReference",
                    "value": "0173-1#02-ABI791#001/0173-1#01-AHX447#001"
                  }
                ]
              },
              "value": [
                {
                  "idShort": "DigitalFile",
                  "displayName": [
                    {
                      "language": "en",
                      "text": "Digital File"
                    },
                    {
                      "language": "de",
                      "text": "Digitale Datei"
                    }
                  ],
                  "description": [
                    {
                      "language": "en",
                      "text": "Computer resource for recording data in a computer storage device, primarily identified by its file name"
                    },
                    {
                      "language": "de",
                      "text": "Computerressource zur Aufzeichnung von Daten in einem Computerspeicherger\u00E4t, die in erster Linie durch ihren Dateinamen identifiziert wird"
                    }
                  ],
                  "semanticId": {
                    "type": "ExternalReference",
                    "keys": [
                      {
                        "type": "GlobalReference",
                        "value": "0173-1#02-ABK126#001"
                      }
                    ]
                  },
                  "value": "https://www.lorenz-meters.de/site/assets/files/1042/logo_lorenz_meters.150x0.png",
                  "contentType": "image/png",
                  "modelType": "File"
                },
                {
                  "idShort": "Comment",
                  "displayName": [
                    {
                      "language": "en",
                      "text": "Comment to File"
                    },
                    {
                      "language": "de",
                      "text": "Anmerkung zur Datei"
                    }
                  ],
                  "description": [
                    {
                      "language": "en",
                      "text": "Explanations that refer to the attached file and relate to its use or origin"
                    },
                    {
                      "language": "de",
                      "text": "Erl\u00E4uterungen die sich auf die Angeh\u00E4ngte Datei beziehen und sich auf deren Verwendung oder Ursprung beziehen"
                    }
                  ],
                  "semanticId": {
                    "type": "ExternalReference",
                    "keys": [
                      {
                        "type": "GlobalReference",
                        "value": "0173-1#02-ABI768#001"
                      }
                    ]
                  },
                  "value": [
                    {
                      "language": "en",
                      "text": "Picture of the display"
                    }
                  ],
                  "modelType": "MultiLanguageProperty"
                }
              ],
              "modelType": "SubmodelElementCollection"
            }
          ],
          "modelType": "SubmodelElementCollection"
        }
      ],
      "modelType": "SubmodelElementCollection"
    },
    {
      "idShort": "OnsiteContact",
      "displayName": [
        {
          "language": "en",
          "text": "Onsite contact"
        },
        {
          "language": "de",
          "text": "Ansprechpartner vor Ort"
        }
      ],
      "description": [
        {
          "language": "en",
          "text": "Collection of one or more natural persons located in the same or close locality to the asset"
        },
        {
          "language": "de",
          "text": "Sammlung von einer oder mehreren nat\u00FCrlichen Personen die sich in der gleichen oder nahen Lokalit\u00E4t zu dem Assets befinden"
        }
      ],
      "semanticId": {
        "type": "ExternalReference",
        "keys": [
          {
            "type": "GlobalReference",
            "value": "0173-1#02-ABI793#001/0173-1#01-AHX449#001"
          }
        ]
      },
      "value": [
        {
          "idShort": "PartnerNumber",
          "displayName": [
            {
              "language": "en",
              "text": "Partner number"
            },
            {
              "language": "de",
              "text": "Partnernummer"
            }
          ],
          "description": [
            {
              "language": "en",
              "text": "An alphanumeric key that identifies a business partner"
            },
            {
              "language": "de",
              "text": "Ein alphanumerischer Schl\u00FCssel, der einen Gesch\u00E4ftspartner identifiziert"
            }
          ],
          "semanticId": {
            "type": "ExternalReference",
            "keys": [
              {
                "type": "GlobalReference",
                "value": "0173-1#02-ABI771#001"
              }
            ]
          },
          "valueType": "xs:string",
          "modelType": "Property"
        },
        {
          "idShort": "NumberOfContacts",
          "displayName": [
            {
              "language": "en",
              "text": "Number of contacts"
            },
            {
              "language": "de",
              "text": "Anzahl der Kontakte"
            }
          ],
          "semanticId": {
            "type": "ExternalReference",
            "keys": [
              {
                "type": "GlobalReference",
                "value": "0173-1#02-AAO203#004"
              }
            ]
          },
          "valueType": "xs:string",
          "modelType": "Property"
        },
        {
          "idShort": "ContactInformation",
          "displayName": [
            {
              "language": "en",
              "text": "Contact Information"
            },
            {
              "language": "de",
              "text": "Kontaktinformation"
            }
          ],
          "description": [
            {
              "language": "en",
              "text": "The SMC \u201CContactInformation\u201D contains information on how to contact the manufacturer or an authorised service provider, e.g. when a maintenance service is required. Note: physical address is a mandatory property according to EU Machine Directive 2006/42/EC"
            },
            {
              "language": "de",
              "text": "Die SMC-\u201EKontaktinformationen\u201C enthalten Angaben zur Kontaktaufnahme mit dem Hersteller oder einem autorisierten Servicepartner, z. B. im Wartungsfall. Hinweis: Die Angabe einer physischen Adresse ist gem\u00E4\u00DF EU-Maschinenrichtlinie 2006/42/EG obligatorisch."
            }
          ],
          "semanticId": {
            "type": "ExternalReference",
            "keys": [
              {
                "type": "GlobalReference",
                "value": "0173-1#02-AAQ837#007/0173-1#01-ADR448#007"
              }
            ]
          },
          "qualifiers": [
            {
              "type": "Multiplicity",
              "valueType": "xs:string",
              "value": "One"
            }
          ],
          "value": [
            {
              "idShort": "RoleOfContactPerson",
              "displayName": [
                {
                  "language": "en",
                  "text": "Role of Contact Person"
                },
                {
                  "language": "de",
                  "text": "Rolle der Kontaktperson"
                }
              ],
              "description": [
                {
                  "language": "en",
                  "text": "Function of a contact person in a process"
                },
                {
                  "language": "de",
                  "text": "Funktion einer Kontaktperson in einem Prozess"
                }
              ],
              "semanticId": {
                "type": "ExternalReference",
                "keys": [
                  {
                    "type": "GlobalReference",
                    "value": "0173-1#02-AAO204#003"
                  }
                ]
              },
              "qualifiers": [
                {
                  "type": "Multiplicity",
                  "valueType": "xs:string",
                  "value": "ZeroToOne"
                }
              ],
              "valueType": "xs:string",
              "value": "0173-1#07-AAS928#001",
              "modelType": "Property"
            },
            {
              "idShort": "NationalCode",
              "displayName": [
                {
                  "language": "en",
                  "text": "National Code"
                },
                {
                  "language": "de",
                  "text": "Nationaler Code"
                }
              ],
              "description": [
                {
                  "language": "en",
                  "text": "Code of a country"
                },
                {
                  "language": "de",
                  "text": "Code eines Landes"
                }
              ],
              "semanticId": {
                "type": "ExternalReference",
                "keys": [
                  {
                    "type": "GlobalReference",
                    "value": "0173-1#02-AAO134#002"
                  }
                ]
              },
              "qualifiers": [
                {
                  "type": "Multiplicity",
                  "valueType": "xs:string",
                  "value": "One"
                }
              ],
              "value": [
                {
                  "language": "en",
                  "text": "DE"
                }
              ],
              "modelType": "MultiLanguageProperty"
            },
            {
              "idShort": "Language",
              "displayName": [
                {
                  "language": "en",
                  "text": "Language"
                },
                {
                  "language": "de",
                  "text": "Sprache"
                }
              ],
              "description": [
                {
                  "language": "en",
                  "text": "Available language"
                },
                {
                  "language": "de",
                  "text": "Available language"
                }
              ],
              "semanticId": {
                "type": "ExternalReference",
                "keys": [
                  {
                    "type": "GlobalReference",
                    "value": "https://admin-shell.io/zvei/nameplate/1/0/ContactInformations/ContactInformation/Language"
                  }
                ]
              },
              "qualifiers": [
                {
                  "type": "Multiplicity",
                  "valueType": "xs:string",
                  "value": "ZeroToMany"
                }
              ],
              "valueType": "xs:string",
              "value": "de",
              "modelType": "Property"
            },
            {
              "idShort": "TimeZone",
              "displayName": [
                {
                  "language": "en",
                  "text": "Time Zone"
                },
                {
                  "language": "de",
                  "text": "Zeitzone"
                }
              ],
              "description": [
                {
                  "language": "en",
                  "text": "Offsets from Coordinated Universal Time (UTC)"
                },
                {
                  "language": "de",
                  "text": "Abweichungen von der koordinierten Weltzeit (UTC)"
                }
              ],
              "semanticId": {
                "type": "ExternalReference",
                "keys": [
                  {
                    "type": "GlobalReference",
                    "value": "https://admin-shell.io/zvei/nameplate/1/0/ContactInformations/ContactInformation/TimeZone"
                  }
                ]
              },
              "qualifiers": [
                {
                  "type": "Multiplicity",
                  "valueType": "xs:string",
                  "value": "ZeroToOne"
                }
              ],
              "valueType": "xs:string",
              "value": "CET",
              "modelType": "Property"
            },
            {
              "idShort": "CityTown",
              "displayName": [
                {
                  "language": "en",
                  "text": "City/Town"
                },
                {
                  "language": "de",
                  "text": "Stadt/Gemeinde"
                }
              ],
              "description": [
                {
                  "language": "en",
                  "text": "Town or city"
                },
                {
                  "language": "de",
                  "text": "Stadt"
                }
              ],
              "semanticId": {
                "type": "ExternalReference",
                "keys": [
                  {
                    "type": "GlobalReference",
                    "value": "0173-1#02-AAO132#002"
                  }
                ]
              },
              "qualifiers": [
                {
                  "type": "Multiplicity",
                  "valueType": "xs:string",
                  "value": "One"
                }
              ],
              "value": [
                {
                  "language": "de",
                  "text": "Schelklingen - Ingstetten"
                }
              ],
              "modelType": "MultiLanguageProperty"
            },
            {
              "idShort": "Company",
              "displayName": [
                {
                  "language": "en",
                  "text": "Company"
                },
                {
                  "language": "de",
                  "text": "Firma"
                }
              ],
              "description": [
                {
                  "language": "en",
                  "text": "Name of the company"
                },
                {
                  "language": "de",
                  "text": "Name des Unternehmens"
                }
              ],
              "semanticId": {
                "type": "ExternalReference",
                "keys": [
                  {
                    "type": "GlobalReference",
                    "value": "0173-1#02-AAW001#001"
                  }
                ]
              },
              "qualifiers": [
                {
                  "type": "Multiplicity",
                  "valueType": "xs:string",
                  "value": "ZeroToOne"
                }
              ],
              "value": [
                {
                  "language": "en",
                  "text": "Lorenz GmbH \u0026 Co.KG"
                }
              ],
              "modelType": "MultiLanguageProperty"
            },
            {
              "idShort": "Department",
              "displayName": [
                {
                  "language": "en",
                  "text": "Department"
                },
                {
                  "language": "de",
                  "text": "Abteilung"
                }
              ],
              "description": [
                {
                  "language": "en",
                  "text": "Administrative section within an organisation where a business partner is located"
                },
                {
                  "language": "de",
                  "text": "Verwaltungsbereich innerhalb einer Organisation, in dem sich ein Gesch\u00E4ftspartner befindet"
                }
              ],
              "semanticId": {
                "type": "ExternalReference",
                "keys": [
                  {
                    "type": "GlobalReference",
                    "value": "0173-1#02-AAO127#003"
                  }
                ]
              },
              "qualifiers": [
                {
                  "type": "Multiplicity",
                  "valueType": "xs:string",
                  "value": "ZeroToOne"
                }
              ],
              "value": [
                {
                  "language": "en",
                  "text": "0173-1#07-AAS928#001"
                }
              ],
              "modelType": "MultiLanguageProperty"
            },
            {
              "idShort": "Phone",
              "displayName": [
                {
                  "language": "en",
                  "text": "Phone"
                },
                {
                  "language": "de",
                  "text": "Telefon"
                }
              ],
              "description": [
                {
                  "language": "en",
                  "text": "Phone number including type"
                },
                {
                  "language": "de",
                  "text": "Telefonnummer inklusive Typ"
                }
              ],
              "semanticId": {
                "type": "ExternalReference",
                "keys": [
                  {
                    "type": "GlobalReference",
                    "value": "https://admin-shell.io/zvei/nameplate/1/0/ContactInformations/ContactInformation/Phone"
                  }
                ]
              },
              "qualifiers": [
                {
                  "type": "Multiplicity",
                  "valueType": "xs:string",
                  "value": "ZeroToOne"
                }
              ],
              "value": [
                {
                  "idShort": "TelephoneNumber",
                  "displayName": [
                    {
                      "language": "en",
                      "text": "Telephone Number"
                    },
                    {
                      "language": "de",
                      "text": "Telefonnummer"
                    }
                  ],
                  "description": [
                    {
                      "language": "en",
                      "text": "Complete telephone number to be called to reach a business partner"
                    },
                    {
                      "language": "de",
                      "text": "Vollst\u00E4ndige Telefonnummer, unter der ein Gesch\u00E4ftspartner erreichbar ist"
                    }
                  ],
                  "semanticId": {
                    "type": "ExternalReference",
                    "keys": [
                      {
                        "type": "GlobalReference",
                        "value": "0173-1#02-AAO136#002"
                      }
                    ]
                  },
                  "qualifiers": [
                    {
                      "type": "Multiplicity",
                      "valueType": "xs:string",
                      "value": "One"
                    }
                  ],
                  "value": [
                    {
                      "language": "en",
                      "text": "\u002B49 (0)7384 / 95 981-0"
                    }
                  ],
                  "modelType": "MultiLanguageProperty"
                },
                {
                  "idShort": "TypeOfTelephone",
                  "displayName": [
                    {
                      "language": "en",
                      "text": "Type of Telephone"
                    },
                    {
                      "language": "de",
                      "text": "Art des Telefons"
                    }
                  ],
                  "description": [
                    {
                      "language": "en",
                      "text": " Characterization of a telephone according to its location or usage"
                    },
                    {
                      "language": "de",
                      "text": "Charakterisierung eines Telefons nach seinem Standort oder seiner Nutzung"
                    }
                  ],
                  "semanticId": {
                    "type": "ExternalReference",
                    "keys": [
                      {
                        "type": "GlobalReference",
                        "value": "0173-1#02-AAO137#003"
                      }
                    ]
                  },
                  "qualifiers": [
                    {
                      "type": "Multiplicity",
                      "valueType": "xs:string",
                      "value": "ZeroToOne"
                    }
                  ],
                  "valueType": "xs:string",
                  "value": "0173-1#07-AAS754#001",
                  "modelType": "Property"
                },
                {
                  "idShort": "AvailableTime",
                  "displayName": [
                    {
                      "language": "en",
                      "text": "Available Time"
                    },
                    {
                      "language": "de",
                      "text": "Verf\u00FCgbare Zeit"
                    }
                  ],
                  "description": [
                    {
                      "language": "en",
                      "text": "Specification of the available time window"
                    },
                    {
                      "language": "de",
                      "text": "Spezifikation des verf\u00FCgbaren Zeitfensters"
                    }
                  ],
                  "semanticId": {
                    "type": "ExternalReference",
                    "keys": [
                      {
                        "type": "GlobalReference",
                        "value": "https://admin-shell.io/zvei/nameplate/1/0/ContactInformations/ContactInformation/AvailableTime/"
                      }
                    ]
                  },
                  "qualifiers": [
                    {
                      "type": "Multiplicity",
                      "valueType": "xs:string",
                      "value": "ZeroToOne"
                    }
                  ],
                  "value": [
                    {
                      "language": "de",
                      "text": "EMPTY"
                    }
                  ],
                  "modelType": "MultiLanguageProperty"
                }
              ],
              "modelType": "SubmodelElementCollection"
            },
            {
              "idShort": "Fax",
              "displayName": [
                {
                  "language": "en",
                  "text": "Fax"
                },
                {
                  "language": "de",
                  "text": "Fax"
                }
              ],
              "description": [
                {
                  "language": "en",
                  "text": "Fax number including type"
                },
                {
                  "language": "de",
                  "text": "Faxnummer inklusive Typ"
                }
              ],
              "semanticId": {
                "type": "ExternalReference",
                "keys": [
                  {
                    "type": "GlobalReference",
                    "value": "0173-1#02-AAQ834#005"
                  }
                ]
              },
              "qualifiers": [
                {
                  "type": "Multiplicity",
                  "valueType": "xs:string",
                  "value": "ZeroToOne"
                }
              ],
              "value": [
                {
                  "idShort": "FaxNumber",
                  "displayName": [
                    {
                      "language": "en",
                      "text": "Fax Number"
                    },
                    {
                      "language": "de",
                      "text": "Faxnummer"
                    }
                  ],
                  "description": [
                    {
                      "language": "en",
                      "text": "Complete telephone number to be called to reach a business partner\u0027s fax machine"
                    },
                    {
                      "language": "de",
                      "text": "Vollst\u00E4ndige Telefonnummer, um das Faxger\u00E4t eines Gesch\u00E4ftspartners zu erreichen"
                    }
                  ],
                  "semanticId": {
                    "type": "ExternalReference",
                    "keys": [
                      {
                        "type": "GlobalReference",
                        "value": "0173-1#02-AAO195#002"
                      }
                    ]
                  },
                  "qualifiers": [
                    {
                      "type": "Multiplicity",
                      "valueType": "xs:string",
                      "value": "One"
                    }
                  ],
                  "value": [
                    {
                      "language": "en",
                      "text": "\u002B49 (0)7384 95 98 1-50"
                    }
                  ],
                  "modelType": "MultiLanguageProperty"
                },
                {
                  "idShort": "TypeOfFaxNumber",
                  "displayName": [
                    {
                      "language": "en",
                      "text": "Type of Fax Number"
                    },
                    {
                      "language": "de",
                      "text": "Art der Faxnummer"
                    }
                  ],
                  "description": [
                    {
                      "language": "en",
                      "text": "Characterization of the fax according its location or usage"
                    },
                    {
                      "language": "de",
                      "text": "Charakterisierung des Faxger\u00E4ts nach Standort oder Nutzung"
                    }
                  ],
                  "semanticId": {
                    "type": "ExternalReference",
                    "keys": [
                      {
                        "type": "GlobalReference",
                        "value": "0173-1#02-AAO196#003"
                      }
                    ]
                  },
                  "qualifiers": [
                    {
                      "type": "Multiplicity",
                      "valueType": "xs:string",
                      "value": "ZeroToOne"
                    }
                  ],
                  "valueType": "xs:string",
                  "value": "0173-1#07-AAS754#001",
                  "modelType": "Property"
                }
              ],
              "modelType": "SubmodelElementCollection"
            },
            {
              "idShort": "Email",
              "displayName": [
                {
                  "language": "en",
                  "text": "Email"
                },
                {
                  "language": "de",
                  "text": "E-Mail"
                }
              ],
              "description": [
                {
                  "language": "en",
                  "text": "E-mail address and encryption method"
                },
                {
                  "language": "de",
                  "text": "E-Mail-Adresse und Verschl\u00FCsselungsmethode"
                }
              ],
              "semanticId": {
                "type": "ExternalReference",
                "keys": [
                  {
                    "type": "GlobalReference",
                    "value": "0173-1#02-AAQ836#005"
                  }
                ]
              },
              "qualifiers": [
                {
                  "type": "Multiplicity",
                  "valueType": "xs:string",
                  "value": "ZeroToOne"
                }
              ],
              "value": [
                {
                  "idShort": "EmailAddress",
                  "displayName": [
                    {
                      "language": "en",
                      "text": "Email Address"
                    },
                    {
                      "language": "de",
                      "text": "E-Mail-Adresse"
                    }
                  ],
                  "description": [
                    {
                      "language": "en",
                      "text": "Electronic mail address of a business partner"
                    },
                    {
                      "language": "de",
                      "text": "E-Mail-Adresse eines Gesch\u00E4ftspartners"
                    }
                  ],
                  "semanticId": {
                    "type": "ExternalReference",
                    "keys": [
                      {
                        "type": "GlobalReference",
                        "value": "0173-1#02-AAO198#002"
                      }
                    ]
                  },
                  "qualifiers": [
                    {
                      "type": "Multiplicity",
                      "valueType": "xs:string",
                      "value": "One"
                    }
                  ],
                  "valueType": "xs:string",
                  "value": "info@lorenz-meters.de",
                  "modelType": "Property"
                },
                {
                  "idShort": "TypeOfEmailAddress",
                  "displayName": [
                    {
                      "language": "en",
                      "text": "Type of Email Address"
                    },
                    {
                      "language": "de",
                      "text": "Art der E-Mail-Adresse"
                    }
                  ],
                  "description": [
                    {
                      "language": "en",
                      "text": "Characterization of an e-mail address according to its location or usage"
                    },
                    {
                      "language": "de",
                      "text": "Charakterisierung einer E-Mail-Adresse nach ihrem Standort oder ihrer Nutzung"
                    }
                  ],
                  "semanticId": {
                    "type": "ExternalReference",
                    "keys": [
                      {
                        "type": "GlobalReference",
                        "value": "0173-1#02-AAO199#003"
                      }
                    ]
                  },
                  "qualifiers": [
                    {
                      "type": "Multiplicity",
                      "valueType": "xs:string",
                      "value": "ZeroToOne"
                    }
                  ],
                  "valueType": "xs:string",
                  "value": "0173-1#07-AAS754#001",
                  "modelType": "Property"
                }
              ],
              "modelType": "SubmodelElementCollection"
            },
            {
              "idShort": "Street",
              "displayName": [
                {
                  "language": "en",
                  "text": "Street"
                },
                {
                  "language": "de",
                  "text": "Stra\u00DFe"
                }
              ],
              "description": [
                {
                  "language": "en",
                  "text": "Street name and house number"
                },
                {
                  "language": "de",
                  "text": "Stra\u00DFenname und Hausnummer"
                }
              ],
              "semanticId": {
                "type": "ExternalReference",
                "keys": [
                  {
                    "type": "GlobalReference",
                    "value": "0173-1#02-AAO128#002"
                  }
                ]
              },
              "qualifiers": [
                {
                  "type": "Multiplicity",
                  "valueType": "xs:string",
                  "value": "One"
                }
              ],
              "value": [
                {
                  "language": "de",
                  "text": "Burgweg 3"
                }
              ],
              "modelType": "MultiLanguageProperty"
            },
            {
              "idShort": "Zipcode",
              "displayName": [
                {
                  "language": "en",
                  "text": "Zip Code"
                },
                {
                  "language": "de",
                  "text": "Postleitzahl"
                }
              ],
              "description": [
                {
                  "language": "en",
                  "text": "ZIP code of address"
                },
                {
                  "language": "de",
                  "text": "Postleitzahl der Adresse"
                }
              ],
              "semanticId": {
                "type": "ExternalReference",
                "keys": [
                  {
                    "type": "GlobalReference",
                    "value": "0173-1#02-AAO129#002"
                  }
                ]
              },
              "qualifiers": [
                {
                  "type": "Multiplicity",
                  "valueType": "xs:string",
                  "value": "One"
                }
              ],
              "value": [
                {
                  "language": "de",
                  "text": "89601"
                }
              ],
              "modelType": "MultiLanguageProperty"
            },
            {
              "idShort": "StateCounty",
              "displayName": [
                {
                  "language": "en",
                  "text": "State/County"
                },
                {
                  "language": "de",
                  "text": "Bundesland/Kreis"
                }
              ],
              "description": [
                {
                  "language": "en",
                  "text": "Federal state a part of a state"
                },
                {
                  "language": "de",
                  "text": "Bundesstaat, Teil eines Bundesstaates"
                }
              ],
              "semanticId": {
                "type": "ExternalReference",
                "keys": [
                  {
                    "type": "GlobalReference",
                    "value": "0173-1#02-AAO133#002"
                  }
                ]
              },
              "qualifiers": [
                {
                  "type": "Multiplicity",
                  "valueType": "xs:string",
                  "value": "ZeroToOne"
                }
              ],
              "value": [
                {
                  "language": "de",
                  "text": "Baden-W\u00FCrttemberg"
                }
              ],
              "modelType": "MultiLanguageProperty"
            },
            {
              "idShort": "AddressOfAdditionalLink",
              "displayName": [
                {
                  "language": "en",
                  "text": "Address of Additional Link"
                },
                {
                  "language": "de",
                  "text": "Adresse des zus\u00E4tzlichen Links"
                }
              ],
              "description": [
                {
                  "language": "en",
                  "text": "Web site address where information about the product or"
                },
                {
                  "language": "de",
                  "text": "Website-Adresse, auf der Informationen \u00FCber das Produkt oder die Kontaktdaten angegeben sind"
                }
              ],
              "semanticId": {
                "type": "ExternalReference",
                "keys": [
                  {
                    "type": "GlobalReference",
                    "value": "0173-1#02-AAQ326#002"
                  }
                ]
              },
              "qualifiers": [
                {
                  "type": "Multiplicity",
                  "valueType": "xs:string",
                  "value": "ZeroToOne"
                }
              ],
              "valueType": "xs:string",
              "value": "https://www.lorenz-meters.de/cms/kontakt-und-hilfe/",
              "modelType": "Property"
            }
          ],
          "modelType": "SubmodelElementCollection"
        }
      ],
      "modelType": "SubmodelElementCollection"
    }
  ],
  "modelType": "SubmodelElementCollection"
};